import React from 'react';
import logoOnLight from '../assets/logo.png';
import logoOnDark from '../assets/logo-light.png';

// Brand logo for the current theme. Both files are rendered and CSS (index.css) hides the one that doesn't fit.
function Logo({ alt = 'Events Ignite', className }) {
  return (
    <>
      <img src={logoOnLight} alt={alt} className={`${className || ''} logo-on-light`} />
      <img src={logoOnDark} alt={alt} className={`${className || ''} logo-on-dark`} />
    </>
  );
}

export default Logo;
